// import gsap from "gsap";

// jQuery(window).load(function () {
//   const openingMovieArea = document.querySelector("#openingMovie");
//   const video = document.querySelector("#openingMovie video");

//   /**
//    * クッキーの処理
//    */

//   if (jQuery.cookie("access") == undefined) {
//     /* アクセス1回目の処理 */
//     jQuery.cookie("access", "onece");

//     // ヘッダーを非表示にセット
//     gsap.set("header.main", { opacity: 0 });

//     if (video) {
//       video.addEventListener("ended", function () {
//         // console.log("ended発生");
//       });

//       video.play(); //動画の再生

//       //動画が終了したことを検出して発火する処理
//       video.addEventListener("ended", function () {
//         gsap.to(video, {
//           opacity: 0,
//           duration: 1,
//           delay: 1,
//           ease: "power2.out",

//           onComplete: () => {
//             //#openingMovieをDOM的に削除
//             openingMovieArea.remove();
//             // ヘッダーを非表示
//             gsap.to("header.main", {
//               opacity: 1,
//               duration: 1,
//               ease: "power2.out",
//             });
//           },
//         });
//       });
//     }
//   } else {
//     /* アクセス2回目以降の処理 */
//     // if (openingMovieArea) {
//     //   openingMovieArea.remove();
//     // }
//     // smoother.paused(true);
//     gsap.set("header.main", { opacity: 0, pointerEvents: "none" });

//     if (video) {
//       video.addEventListener("ended", function () {
//         // console.log("ended発生");
//       });

//       video.play(); //動画の再生

//       //動画が終了したことを検出して発火する処理
//       video.addEventListener("ended", function () {
//         gsap.to(video, {
//           opacity: 0,
//           duration: 1,
//           delay: 1,
//           ease: "power2.out",

//           onComplete: () => {
//             //#openingMovieをDOM的に削除
//             openingMovieArea.remove();
//             // ヘッダーを非表示
//             gsap.to("header.main", {
//               opacity: 1,
//               pointerEvents: "auto",
//               duration: 1,
//               ease: "power2.out",
//             });
//             // smoother.paused(false);
//           },
//         });
//       });
//     }
//   }
// });
